import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';

@Component({
  selector: 'app-view-button',
  template: `
    <a (click)="clickEvent($event)"
            [ngClass]="[disabled?'disabled':'']"
            class="app-view-btn app-pointer" tabindex="-1">
      <span class="fa-stack"><i class="fa fa-square fa-stack-2x"></i><i class="fa fa-eye fa-stack-1x fa-inverse"></i></span>
    </a>
  `
})
export class ViewButtonComponent implements OnInit {
  @Input() disabled: boolean;
  @Input() title: String;
  @Output() onClick = new EventEmitter<any>();

  constructor() {
  }

  ngOnInit() {
  }

  clickEvent(event) {
    if (this.disabled) {
      return;
    }

    this.onClick.emit(event);
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/shared/components/view-button/view-button.component.ts